import { ReducerUtils } from "../constants/reducers";
import { ALL_STATUS } from "../constants";

export default function reducer(state, action) {
  switch (action.type) {
    case ReducerUtils.order.details:
      return {
        ...state,
        orderDetails: action.payload,
      };

    case ReducerUtils.products.config:
      return {
        ...state,
        productConfig: action.payload,
      };

    case ReducerUtils.claims.list:
      return {
        ...state,
        claimsList: action.payload,
        filteredClaimsList: action.payload,
      };

    case ReducerUtils.claims.count:
      return {
        ...state,
        claimsCount: action.payload,
        filteredClaimsCount: action.payload,
      };

    case ReducerUtils.search.text:
      const query = action.payload;
      let filteredList = [];

      if (state?.status === ALL_STATUS) {
        filteredList = [...state.claimsList];
      } else {
        filteredList = state.claimsList.filter((item) => {
          return item.status_text_slug === state?.status;
        });
      }

      if (query) {
        filteredList = state.claimsList.filter((item) => {
          return (
            item.id === Number(query) ||
            (item.mobile && item.mobile.includes(query)) ||
            (item.imei_number &&
              item.imei_number.toLowerCase().includes(query.toLowerCase()))
          );
        });

        return {
          ...state,
          filteredClaimsList: filteredList || [],
          filteredClaimsCount: filteredList.length || 0,
        };
      } else {
        return {
          ...state,
          filteredClaimsList: [...filteredList],
          filteredClaimsCount: Math.ceil(
            filteredList.length / ReducerUtils.claims.perPage
          ), //state.claimsCount
        };
      }

    case ReducerUtils.cards.list:
      return {
        ...state,
        cards: action.payload,
      };

    case ReducerUtils.filter.status:
      const status = action.payload;
      if (status === ALL_STATUS) {
        return {
          ...state,
          status,
          filteredClaimsList: [...state.claimsList],
          filteredClaimsCount: state.claimsCount,
        };
      } else {
        const filteredList = state.claimsList.filter((item) => {
          return item.status_text_slug === status;
        });

        return {
          ...state,
          status,
          filteredClaimsList: filteredList || [],
          filteredClaimsCount: Math.ceil(
            filteredList.length / ReducerUtils.claims.perPage
          ),
        };
      }

    case ReducerUtils.claims.remarks:
      return {
        ...state,
        remarks: action.payload,
      };

    case ReducerUtils.profile.details:
      return {
        ...state,
        profileDetails: action.payload,
      };

    default:
      return state;
  }
}
